/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useCreateBulkExchangeOrders = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/create/bulk/requests`, {
        data,
        successMessage: "Exchange requests created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetExchangeOrders"] });
    },
  });
};

export const useCreateExchangeOrder = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/create/request`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });

export const useGetExchangeOrders = (data: any) =>
  useQuery({
    queryKey: [
      "GetExchangeOrders",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
      data?.customerId,
      data?.sourceSPId,
    ],
    queryFn: ({ signal }) =>
      client(`exchange/services/open/requests`, { data, signal }),
  });

export const useCancelExchangeOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/cancel/services`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetExchangeOrders"] });
    },
  });
};

export const useAssignExchangeRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`exchange/services/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected job(s)!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetExchangeOrders"],
      });
    },
  });
};

export const useGetExchangeDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetExchangeDetails", data?.requestId],
    queryFn: () =>
      client(`exchange/services/request/details/${data?.requestId}`),
    enabled: Boolean(data?.requestId),
  });

export const useEditGetExchangeJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/edit/request`, {
        data,
        successMessage: "Request edited successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetExchangeDetails"] });
    },
  });
};

export const useUpdateExchangeStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetExchangeDetails"] });
    },
  });
};

export const useAssignBagSeals = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/bulk/bags/assignment`, {
        data,
        successMessage: "Bag Seal Assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetExchangeOrders"] });
    },
  });
};

export const useGetSingCurrencyTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/download/single/currency/template`, { data }),
  });

export const useGetMultipleCurrencyTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/download/multiple/currency/template`, {
        data,
      }),
  });

export const useGetCoinsTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/download/coins/template`, { data }),
  });

export const useAssignExchangeBags = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/assign/consignments`, { data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetExchangeDetails"] });
    },
  });
};

export const useUpdateExchangeAfterCompletion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/update/evhr/request`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetExchangeDetails"] });
    },
  });
};

export const useValidateBulkBagsAssignment = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`exchange/services/validate/bulk/bags/assignment`, {
        data,
        errorMessage: "Invalid barcodes found.",
      }),
  });
